import type { ManualSection } from '../manual.types';

export const glosarioSection: ManualSection = {
  slug: 'glosario',
  title: 'Glosario',
  icon: 'ki-book',
  summary: 'Los términos y códigos que aparecen en las pantallas.',
  topics: [
    {
      id: 'terminos',
      title: 'Términos',
      blocks: [
        {
          kind: 'kv',
          items: [
            {
              k: 'CPD',
              v: 'Call Progress Detection. Detectar buzón de voz durante la llamada y cortarla antes de que facture.'
            },
            {
              k: 'Blaster',
              v: 'La plataforma de llamadas salientes masivas. Es quien decide a quién se llama.'
            },
            {
              k: 'FreeSWITCH (FS)',
              v: 'El conmutador que origina las llamadas y ejecuta la detección.'
            },
            { k: 'OpenSIPS', v: 'El proxy SIP que enruta el tráfico hacia los carriers.' },
            {
              k: 'Early media',
              v: 'El audio que se escucha **antes** de que la llamada se conteste: tono de llamada, mensajes del carrier, y el beep del buzón. Es donde trabaja la detección por tono.'
            },
            { k: 'Post-answer', v: 'Después del 200 OK. Es donde trabaja el modo Voice / AMD.' },
            { k: 'Veredicto', v: 'Lo que decidió el CPD: buzón, humano, sin veredicto, o bypass.' },
            { k: 'Bypass', v: 'La llamada pasó sin aplicarle CPD, por configuración.' },
            {
              k: 'Operador (operatorId)',
              v: 'Dimensión de negocio que manda el Blaster. Identifica al carrier o cliente de esa llamada.'
            },
            {
              k: 'Grupo de ruta (routeGroupId)',
              v: 'Número que identifica la ruta: 10 Telcel, 20 AT&T, 30 Movistar, 40 Altán, 99 onering.'
            },
            { k: 'Template', v: 'Política de CPD completa y con nombre, para reutilizar.' },
            {
              k: 'Override',
              v: 'Ajuste puntual que se encima a la política heredada. Vacío = heredar.'
            },
            {
              k: 'Política efectiva',
              v: 'El resultado final de aplicar todas las capas para una combinación operador + ruta.'
            },
            {
              k: 'callUuid',
              v: 'Identificador único de una llamada. La llave para rastrearla en cualquier sistema.'
            },
            { k: 'billsec', v: 'Segundos **conectados** de la llamada. Es lo facturable.' },
            {
              k: 'duration',
              v: 'Segundos totales del canal, incluyendo el tiempo que estuvo sonando.'
            },
            {
              k: 'Tick',
              v: 'El envío que hace el servidor cada segundo con el estado del dashboard en vivo.'
            },
            {
              k: 'Ventana móvil',
              v: 'Los últimos N segundos contados desde ahora, recalculados en cada tick.'
            }
          ]
        }
      ]
    },
    {
      id: 'causas-de-colgado',
      title: 'Causas de colgado que vas a ver seguido',
      blocks: [
        {
          kind: 'table',
          head: ['Causa', 'Qué significa'],
          rows: [
            ['`NORMAL_CLEARING`', 'La llamada terminó normalmente, alguno de los dos colgó.'],
            [
              '`CALL_REJECTED`',
              'Rechazada. **Es la que deja el CPD al cortar un buzón** (causa 21, SIP 603).'
            ],
            ['`NO_ANSWER`', 'Sonó y nadie contestó.'],
            ['`USER_BUSY`', 'Ocupado.'],
            ['`ORIGINATOR_CANCEL`', 'El originador canceló antes de que contestaran.'],
            ['`NORMAL_TEMPORARY_FAILURE`', 'Falla temporal de la red o del carrier.'],
            ['`RECOVERY_ON_TIMER_EXPIRE`', 'Se venció un temporizador sin respuesta.']
          ]
        },
        {
          kind: 'note',
          tone: 'info',
          title: 'Cómo distinguir un corte del CPD de otro rechazo',
          text: 'No basta la causa: hay que mirar también el `sip_term_status`. Un corte del CPD es `CALL_REJECTED` **con** `sip_term_status = 603`. En el detalle de la llamada vienen los dos campos.'
        }
      ]
    },
    {
      id: 'codigos-sip',
      title: 'Códigos SIP frecuentes',
      blocks: [
        {
          kind: 'table',
          head: ['Código', 'Nombre', 'En este contexto'],
          align: ['center', 'start', 'start'],
          rows: [
            ['200', 'OK', 'Contestaron. Cuenta como "contestada", aunque sea un buzón.'],
            ['404', 'Not Found', 'El número no existe.'],
            ['408', 'Request Timeout', 'Sin respuesta a tiempo.'],
            [
              '480',
              'Temporarily Unavailable',
              'No disponible. Suele ser apagado o fuera de cobertura.'
            ],
            ['486', 'Busy Here', 'Ocupado.'],
            ['487', 'Request Terminated', 'Se canceló antes de que contestaran.'],
            ['**603**', '**Decline**', '**El corte del CPD al detectar buzón.**']
          ]
        }
      ]
    }
  ]
};
